export const VAPID_PUBLIC_KEY = "BLlJ4Ay3tJLeDuZcCL_XyZ6A4DjwfeM0AZoSPe9fM3aR0aIDGV7eTSwVNYAzy-rSZJX7VcO6iupgBMgUeKvee74";